import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

export const alertService = {
  toast: ({ icon = 'success', title = '' }) => {
    const isDark = document.documentElement.classList.contains('dark');
    return Toast.fire({
      icon,
      title,
      background: isDark ? '#1e293b' : '#ffffff',
      color: isDark ? '#f1f5f9' : '#0f172a',
    });
  },

  alert: ({ title, text, icon = 'info' }) => {
    const isDark = document.documentElement.classList.contains('dark');
    return Swal.fire({
      title,
      text,
      icon,
      background: isDark ? '#1e293b' : '#ffffff',
      color: isDark ? '#f1f5f9' : '#0f172a',
      confirmButtonColor: '#3b82f6',
    });
  },

  success: (title, text) => alertService.alert({ title, text, icon: 'success' }),
  error: (title, text) => alertService.alert({ title, text, icon: 'error' }),
  warning: (title, text) => alertService.alert({ title, text, icon: 'warning' }),

  confirm: async ({
    title = 'Are you sure?',
    text = "You won't be able to revert this!",
    icon = 'warning',
    confirmButtonText = 'Yes, confirm!',
    cancelButtonText = 'Cancel'
  } = {}) => {
    const isDark = document.documentElement.classList.contains('dark');
    const result = await Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      background: isDark ? '#1e293b' : '#ffffff',
      color: isDark ? '#f1f5f9' : '#0f172a',
      confirmButtonColor: '#3b82f6',
      cancelButtonColor: '#ef4444',
      reverseButtons: true
    });
    return result.isConfirmed;
  }
};

export default alertService;
